module.exports = __webpack_public_path__ + "img/Molotov_Cocktail_demo.d067e381.gif";